<template>
<panel>
      <p slot="header">Zmień swoje hasło</p>

      <form @submit.prevent="submit" autocomplete="off">

            <ui-textbox label="Twoje hasło" name="password" type="password" v-model="form.password" validation-rules="required|min:6|max:16" :validation-messages="errorMessages" autocomplete="off" help-text="Wybierz nowe hasło które ma minimum 6 znaków i maksimum 18"></ui-textbox>
            <ui-textbox label="Twoje hasło (powtórz)" name="password2" type="password" v-model="form.password2" validation-rules="required|min:6|max:16" :validation-messages="errorMessages" autocomplete="off" help-text="Powtórz hasło wpisane wyżej"></ui-textbox>

            <ui-button color="primary">Zmień hasło</ui-button> <ui-button @click="$router.push({name: 'admin.my'})" color="default">Anuluj</ui-button>
      </form>
</panel>
</template>
<script>
import Loading from '../../mixins/Loading'
import Notify from '../../mixins/Notify'

import Auth from './../../services/Auth'
import FormErrors from './../../mixins/FormErrors'
import Utils from './../../services/Utils'

export default {
  mixins: [FormErrors, Loading, Notify],
  data () {
    return {
      form: {
        password: '',
        password2: ''
      },
      errorMessages: Utils.errorMessages(['required', 'min', 'max'])
    }
  },
  methods: {
    success () {
      this.notify('Zmieniłeś swoje hasło')
      this.setLoading(false)
      this.$router.push({
        name: 'admin.my'
      })
    },
    error (err) {
      console.log(err)
      const errors = this.getResponseErrors(err)
      console.log(errors)
      this.notify('Nie mogłem zmienić hasła. Upewnij się że wpisane hasła są takie same i mają odpowiednia długość')
      this.setLoading(false)
    },
    submit () {
      this.msg = false
      this.setLoading(true)
      Auth.changePassword(this.form).then(this.success, this.error)
    }
  }
}
</script>


// WEBPACK FOOTER //
// ChangePassword.vue?40e140a8